import Modulo7 from "../pages/modulo7/Modulo7";
import Modulo7U1A1 from "../pages/modulo7/unidad1/Actividad1";
import Modulo7U1A2 from "../pages/modulo7/unidad1/Actividad2";
import Modulo7U1A3 from "../pages/modulo7/unidad1/Actividad3";
import Modulo7U1A4 from "../pages/modulo7/unidad1/Actividad4";
import Modulo7U1A5 from "../pages/modulo7/unidad1/Actividad5";
import Modulo7U1A6 from "../pages/modulo7/unidad1/Actividad6";
import Modulo7U1A7 from "../pages/modulo7/unidad1/Actividad7";
import Modulo7U1A8 from "../pages/modulo7/unidad1/Actividad8";
//import Modulo7U1A9 from "../pages/modulo7/unidad1/Actividad9";

export const modulo7 = {
  title: "¿Tenemos derechos y también deberes?",
  grade: { name: "Nivel 2", url: "/nivel-2" },
  module: "Módulo 7",
  year: 'Segundo grado',
  tags: [
    { name: "derechos", url: "derechos" },
    { name: "deberes", url: "deberes" },
    { name: "responsabilidad", url: "responsabilidad" },
    { name: "derechos de los niños", url: "derechos-de-los-ninos" },
  ],
  skills: [
    { name: "Construye su identidad", url: "/construye-su-identidad" },
    {
      name: "Convive y participa democráticamente",
      url: "/convive-y-participa-democraticamente",
    },
  ],
  url: "tenemos-derechos-y-tambien-deberes",
  color: "blue",
  component: <Modulo7 />,
  conclusion: "",
  content: [
    {
      name: "Unidad 1",
      path: "unidad-1",
      activities: [
        {
          name: "Actividad 1",
          path: "actividad-1",
          component: <Modulo7U1A1 />,
        },
        {
          name: "Actividad 2",
          path: "actividad-2",
          component: <Modulo7U1A2 />,
        },
        {
          name: "Actividad 3",
          path: "actividad-3",
          component: <Modulo7U1A3 />,
        },
        {
          name: "Actividad 4",
          path: "actividad-4",
          component: <Modulo7U1A4 />,
        },
        {
          name: "Actividad 5",
          path: "actividad-5",
          component: <Modulo7U1A5 />,
        },
        {
          name: "Actividad 6",
          path: "actividad-6",
          component: <Modulo7U1A6 />,
        },
        {
          name: "Actividad 7",
          path: "actividad-7",
          component: <Modulo7U1A7 />,
        },
        {
          name: "Actividad 8",
          path: "actividad-8",
          component: <Modulo7U1A8 />,
        },
      ],
    },
  ],
};
